import { Instance } from "mobx-state-tree"
import { GameResponseModelBase } from "./GameResponseModel.base"

/* The TypeScript type of an instance of GameResponseModel */
export interface GameResponseModelType extends Instance<typeof GameResponseModel.Type> {}

/* A graphql query fragment builders for GameResponseModel */
export { selectFromGameResponse, gameResponseModelPrimitives, GameResponseModelSelector } from "./GameResponseModel.base"

/**
 * GameResponseModel
 */
export const GameResponseModel = GameResponseModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
